import { getScrollPosition } from "@montana/helpers/on-scroll.helper";
// import { headerHeight } from "@montana/helpers/header-height.helper";
// import { headerIsHidden } from "@montana/shell/header/header.component";
import { isBrowser } from "./browser.helper";

// detect support for the behavior property in ScrollOptions
let supportsNativeSmoothScroll = false;
if (isBrowser) {
    supportsNativeSmoothScroll = 'scrollBehavior' in document.documentElement.style;
}

export function scrollTop(): void {
    if (isBrowser) {
        if (supportsNativeSmoothScroll) {
            window.scrollTo({ top: 0, left: 0 });
        } else {
            // IE, Edge etc. does not support obj as argument
            window.scrollTo(0, 0);
        }
    }
}


export const scrollToElement = (id: string): void => {

    if (!isBrowser) {
        return;
    }

    const element = document.getElementById(id);
    if (element) {
        const { top: elementYPosition } = element.getBoundingClientRect();
        const { y: currentYScroll } = getScrollPosition();
        // const currentHeaderHeight = headerIsHidden ? 100 : headerHeight.getHeight();
        const offset = 30;

        const targetY = currentYScroll + elementYPosition - offset; // - currentHeaderHeight

        if (supportsNativeSmoothScroll) {
            window.scrollTo({ behavior: "smooth", top: targetY });
        } else {
            // IE, Edge etc.
            window.scrollTo(0, targetY);
        }
    }

};

/**
 * Scroll (vertical) to an element within a div without scrolling the entire page.
 * @param parentElementOrId Parent element or the id to get the parent element
 * @param childElementOrId Child element or the id to get the child element
 * @param center scroll to center if possible, first child will scroll to top
 */
export const scrollParentToChild = (parentElementOrId: string | HTMLElement, childElementOrId: string | HTMLElement, center?: boolean) => {
    if (!isBrowser) {
        return;
    }

    const parent = typeof parentElementOrId === 'string' ? document.getElementById(parentElementOrId) : parentElementOrId;
    const child = typeof childElementOrId === 'string' ? document.getElementById(childElementOrId) : childElementOrId;

    if (!parent || !child) {
        return;
    }

    // Where is the parent on page
    const parentRect = parent.getBoundingClientRect();
    // What can you see?
    const parentViewableArea = {
        height: parent.clientHeight,
        width: parent.clientWidth
    };

    // Where is the child
    const childRect = child.getBoundingClientRect();

    // Is the child viewable?
    const isViewable = (childRect.top >= parentRect.top) && (childRect.top <= parentRect.top + parentViewableArea.height);

    let targetY = childRect.top + parent.scrollTop - parentRect.top;

    // If center we set the offset to half the parent height minus half the child height
    if (center) {
        targetY = targetY - (parentRect.height / 2) + (childRect.height / 2);
    }

    // if you can't see the child try to scroll parent
    if (!isViewable) {
        parent.scrollTo({ behavior: "smooth", top: targetY >= 0 ? targetY : 0 });
    }

}